export default __webpack_public_path__ + "static/media/medicalEmpty.eb8ca042.svg";